import { ReactElement } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Home } from "../pages/Home";
import { Login } from "../pages/Login";
import { RecuperacaoSenha } from "../pages/RecuperacaoSenha";
import { useAuth } from "../context/AuthContext";
import { Atendimento } from "../pages/Atendimento";
import { Operador } from "../pages/Operador";
import { OperadorCaixa } from "../pages/OperadorCaixa";
import { AnaliseContraProposta } from "../pages/BackOffice/AnaliseContraProposta";
import { Consulta } from "../pages/Consulta";
import { Hibrido } from "../pages/Hibrido";
import { Cadastro } from "../pages/Cadastro";
import { CadastroUsuario } from '../pages/Suporte/CadastroUsuario'
import { OperadorLojaWhatsApp } from '../pages/OperadorLojaWhatsApp'
import { Perfil } from "../pages/Perfil";

interface RouterProps {
  versao: string
}

export const Router = ({ versao }: RouterProps): ReactElement => {
  const { isAuthenticated, cookies, validToken } = useAuth();



  function privateRoutes(Component: React.ElementType<any>, path?: string) {
    if (isAuthenticated || cookies?.token) {
      validToken(cookies?.token);
      return <Component />;
    } else {
      // validToken()
      return <Navigate to="/" replace />;
    }
  }





  return (
    <>
      <Routes>
        <Route path="/" element={<Login versao={versao} />} />
        <Route path="/reset-password" element={<RecuperacaoSenha />} />
        {/* Rotas privadas universais */}
        <Route path="/home" element={privateRoutes(Home)} />
        <Route path="/callback" element={privateRoutes(Atendimento)} />
        <Route path="/operador" element={privateRoutes(Operador)} />
        <Route path="/operador-caixa" element={privateRoutes(OperadorCaixa)} />
        <Route path="/operador-loja-whats" element={privateRoutes(OperadorLojaWhatsApp)} />
        <Route
          path="/analise-contra-proposta"
          element={privateRoutes(AnaliseContraProposta)}
        />
        <Route path="/hibrido" element={privateRoutes(Hibrido)} />
        <Route path="/consulta" element={privateRoutes(Consulta)} />
        <Route path="/cadastro" element={privateRoutes(Cadastro)} />
        <Route path="/suporte/usuario" element={privateRoutes(CadastroUsuario)} />
        <Route path="/perfil" element={privateRoutes(Perfil)} />
      </Routes>
    </>
  );
};
